export default __webpack_public_path__ + "static/media/exclamation_Mark.e51a1d77.svg";